import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { NavbarItemType } from "../../types/navbar.types";

type _NavbarItemProp = {
  navbarTabItem: NavbarItemType;
  activeTabItem: string;
  handleActiveTabChange: Function;
};

function NavbarItems({
  navbarTabItem,
  activeTabItem,
  handleActiveTabChange,
}: _NavbarItemProp) {
  const { t } = useTranslation();
  const activeClassName =
    activeTabItem === navbarTabItem.id
      ? "font-bold text-secondaryText dark:text-secondaryTextDark"
      : "dark:text-primaryTextDark text-primaryText";
  return (
    <div>
      <Link
        to={navbarTabItem.href}
        onClick={() => handleActiveTabChange(navbarTabItem.id)}
        className={`hover:text-secondaryText dark:hover:text-secondaryTextDark text-sm ${activeClassName}`}
      >
        {t(navbarTabItem.id)}
      </Link>
    </div>
  );
}

export default NavbarItems;
